import { useState } from 'react';
import { ColumnEntity } from '../../types';

export const useDraggedItem = (list: ColumnEntity[]) => {
  const [draggedItem, setDraggedItem] = useState<ColumnEntity>();

  const onDragStart = (id: string) => {
    const activeItem = list.find((entity) => entity.id === id);
    setDraggedItem(activeItem || undefined);
  };

  const onDragEnd = () => {
    setDraggedItem(undefined);
  };

  const dragHandlers = {
    onDragStart,
    onDragEnd,
  };
  return { draggedItem, dragHandlers };
};
